import { render } from "./projectUsers.vue?vue&type=template&id=0237d1e8&scoped=true"
import script from "./projectUsers.vue?vue&type=script&lang=js"
export * from "./projectUsers.vue?vue&type=script&lang=js"

import "./projectUsers.vue?vue&type=style&index=0&id=0237d1e8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0237d1e8"]])

export default __exports__